module.exports = __webpack_public_path__ + "static/media/telnyx-logo.fa62e5fc.png";